import { render, staticRenderFns } from "./ViewDocs.vue?vue&type=template&id=71ef4c36&"
import script from "./ViewDocs.vue?vue&type=script&lang=js&"
export * from "./ViewDocs.vue?vue&type=script&lang=js&"
import style0 from "./ViewDocs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports